import axios from "axios";

export const loginWithOtp = async (otp, mobile, fullName) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASEURL}/api/user/otpverify`, { mobile, otp, fullName });
        return response.data;
    } catch (err) {
        return err.message;
    }
}